document.addEventListener('DOMContentLoaded', function() {
  const testimonialSections = document.querySelectorAll('.testimonials-section');
  
  testimonialSections.forEach(section => {
    const testimonials = section.querySelectorAll('.testimonial-item');
    const images = section.querySelectorAll('.testimonial-image');
    const prevBtn = section.querySelector('.nav-prev');
    const nextBtn = section.querySelector('.nav-next');
    
    if (testimonials.length === 0) return;
    
    let currentIndex = 0;
    let autoplayInterval;
    
    // Get autoplay speed from section settings (if implemented)
    const autoplaySpeed = parseInt(section.dataset.autoplaySpeed) || 0;
    
    function showTestimonial(index) {
      // Hide current testimonial with fade out
      testimonials[currentIndex].classList.add('fade-out');
      testimonials[currentIndex].classList.remove('active');
      images[currentIndex].classList.remove('active');
      
      // Show new testimonial after a brief delay
      setTimeout(() => {
        testimonials[currentIndex].classList.remove('fade-out');
        
        currentIndex = index;
        
        testimonials[currentIndex].classList.add('active');
        images[currentIndex].classList.add('active');
        
        // Update button states
        updateButtonStates();
      }, 250);
    }
    
    function updateButtonStates() {
      // Optional: disable buttons at ends
      // prevBtn.disabled = currentIndex === 0;
      // nextBtn.disabled = currentIndex === testimonials.length - 1;
    }
    
    function nextTestimonial() {
      const nextIndex = (currentIndex + 1) % testimonials.length;
      showTestimonial(nextIndex);
    }
    
    function prevTestimonial() {
      const prevIndex = (currentIndex - 1 + testimonials.length) % testimonials.length;
      showTestimonial(prevIndex);
    }
    
    // Event listeners
    nextBtn.addEventListener('click', () => {
      nextTestimonial();
      resetAutoplay();
    });
    
    prevBtn.addEventListener('click', () => {
      prevTestimonial();
      resetAutoplay();
    });
    
    // Autoplay functionality
    function startAutoplay() {
      if (autoplaySpeed > 0) {
        autoplayInterval = setInterval(nextTestimonial, autoplaySpeed * 1000);
      }
    }
    
    function resetAutoplay() {
      clearInterval(autoplayInterval);
      startAutoplay();
    }
    
    // Keyboard navigation
    section.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevTestimonial();
        resetAutoplay();
      } else if (e.key === 'ArrowRight') {
        nextTestimonial();
        resetAutoplay();
      }
    });
    
    // Touch/swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    
    section.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });
    
    section.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });
    
    function handleSwipe() {
      if (touchEndX < touchStartX - 50) {
        nextTestimonial();
        resetAutoplay();
      }
      if (touchEndX > touchStartX + 50) {
        prevTestimonial();
        resetAutoplay();
      }
    }
    
    // Initialize
    updateButtonStates();
    startAutoplay();
  });
});